import { useState } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'
import { WorkflowsService, type ChatPlanRead, type WorkflowWrite } from '../../client'
import { apiErrorMessage } from '../../lib/api'
import posthog from '../../lib/posthog'
import { useAuth } from '../../providers/auth/useAuth'
import WorkflowEditor from './WorkflowEditor'

export default function SaveWorkflowButton({ plan, className }: { plan: ChatPlanRead; className: string }) {
  const { brand } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState<WorkflowWrite | null>(null)

  async function start() {
    if (!brand) return
    setOpen(true)
    setDraft(null)
    try {
      setDraft(await WorkflowsService.draftWorkflow(brand.id, { thread_id: plan.thread_id, plan_id: plan.id }))
    } catch (err) {
      setOpen(false)
      toast.error(apiErrorMessage(err))
    }
  }

  async function save(workflow: WorkflowWrite) {
    if (!brand) return
    await WorkflowsService.createWorkflow(brand.id, workflow)
    posthog.capture('workflow_saved', { steps: workflow.steps.length, inputs: workflow.inputs?.length ?? 0 })
    setOpen(false)
    toast.success('Saved to Workflows', {
      action: { label: 'Open', onClick: () => void navigate('/workflows') },
    })
  }

  return (
    <>
      <button type="button" onClick={() => void start()} className={className}>
        Save as workflow
      </button>
      {open && (
        <WorkflowEditor
          title="Save as workflow"
          initial={draft}
          saveLabel="Save workflow"
          onSave={save}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
